import React from "react";
import LeaderBoard from "../../components/LeaderBoard/LeaderBoard";
const Leaderboard = () => {
  return (
    <LeaderBoard/>
  );
};
export { Leaderboard };
